import React from "react";
import SelectAfectacionIncidencia from "../../selectores/SelectAfectacionIncidencia";

const CampoComboAfectacionIncidencia = (props) => {
  const valor = props.valor;
  const editar = props.editar;
  const incluirNulo = props.incluirNulo;
  const estilo = props.estilo;

  const onAfectacionElegida = (afectacionElegida) => {
    props.onAfectacionElegida(afectacionElegida);
  };

  let campo = "";
  if (editar) {
    campo = (
      <SelectAfectacionIncidencia
        codigoActual={valor}
        incluirNulo={incluirNulo}
        estilo={estilo}
        onAfectacionElegida={onAfectacionElegida}
      />
    );
  } else {
    campo = valor ? valor.descripcion : "";
  }

  return <React.Fragment>{campo}</React.Fragment>;
};

export default CampoComboAfectacionIncidencia;
